import Divider from "../../components/pages/about/Divider";
import Header from "../../components/pages/about/Header";
import { Box } from "@mui/material";
import { cloudfrontUrl } from "../../constants/imageUrl";
import News from "../../components/pages/about/News";
import Careers from "../../components/pages/about/Careers";
import { useEffect } from "react";
import { updatePageSEO, seoConfigs } from "../../utils/seo";
import Contact from "../../components/pages/about/Contact";

export default function AboutPage() {
  useEffect(() => {
    // Update SEO for about page
    updatePageSEO(seoConfigs.about);
  }, []);

  return (
    <Box
      component="main"
      sx={{ position: "relative" }}
      role="main"
      aria-labelledby="about-main-heading"
    >
      {/* 고정된 배경 레이어 */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${cloudfrontUrl}/about/KSM_pattern_01-01.jpg)`,
          backgroundRepeat: "repeat",
          backgroundSize: "200px 200px",
          zIndex: -1, // 맨 뒤로 보내기
        }}
      />

      {/* 실제 콘텐츠 */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          <Header />
        </Box>
        <Divider />
        <Box>
          <Contact />
        </Box>
        <Divider />
        <Box>
          <News />
        </Box>
        <Divider />
        <Box>
          <Careers />
        </Box>
        <Divider />
      </Box>
    </Box>
  );
}
